module.exports = __webpack_public_path__ + "static/portfolio-8-9668c6ee2264431d0f0d5f7cc8e279b5.jpg";